import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { IOrderTrackingData } from '../../../../utils/order-status/interfaces'

const bem = new BEMHelper('Timeline')

type TimelineProps = {
    orderPrimaryStatus: IOrderTrackingData
    orderTrackingData: IOrderTrackingData[]
}

const Timeline: React.FC<TimelineProps> = ({ orderPrimaryStatus, orderTrackingData }) => {
    const activeStep = orderTrackingData?.findIndex((s) => s.status === orderPrimaryStatus.status)
    const smallTimeLineSteps = 3;
    const largeTimeline = orderTrackingData.length > smallTimeLineSteps;

    return (
        <div className={bem(null,  activeStep === -1 ? 'hide' : '')}>
            <ul className={bem('timeline')}>
                {orderTrackingData.map(({ status }, idx) => {
                    return (
                        <li
                            key={status}
                            className={bem('status', {
                                complete: idx <= activeStep,
                                active: idx === activeStep,
                                largeTimeline: largeTimeline
                            })}
                        ></li>
                    )
                })}
            </ul>
        </div>
    )
}

export default Timeline
